const applets = [
    {
        "text": "Application-Crop",
        "icon": "/image/application/cropApplication.svg",
        "path": "applicationDraft",
        "id": "TwCropApplicationApplet",
        "crop": true,
        "category": "customer"
    },
    {
        "text": "Application-Processing",
        "icon": "/image/application/processingApplication.svg",
        "path": "applicationDraftProcessing",
        "id": "ApplicationApplet",
        "processing": true,
        "category": "customer"
    },
    {
        "text": "Crop mark application",
        "icon": "/image/application/cropMarkApplication.svg",
        "path": "cropMarkApplication",
        "id": "CropMarkApplication",
        "belongTo": "crop",
        "crop": true,
        "category": "customer"
    },
    {
        "text": "Crop mark declare",
        "icon": "/image/application/cropDeclare.svg",
        "path": "cropMarkDeclare",
        "id": "CropMarkDeclare",
        "crop": true,
        "category": "customer"
    },
    {
        "text": "Crop mark applying records",
        "icon": "/image/application/cropMarkRecord.svg",
        "path": "cropMarkApplyRecords",
        "id": "CropMarkApplyRecord",
        "crop": true,
        "category": "customer"
    },
    {
        "text": "To do list",
        "icon": "/image/application/cropInbox.svg",
        "path": "cropinbox",
        "id": "Inbox",
        "crop": true,
        "category": "customer"
    },
    {
        "text": "Processing mark application",
        "icon": "/image/application/processingMarkApplication.svg",
        "path": "processingMarkApplication",
        "id": "ProcessingMarkApplication",
        "processing": true,
        "category": "customer"
    },
    {
        "text": "Processing mark declare",
        "icon": "/image/application/processingDeclare.svg",
        "path": "processingMarkDeclare",
        "id": "ProcessingMarkDeclare",
        "processing": true,
        "category": "customer"
    },
    {
        "text": "Processing applying records",
        "icon": "/image/application/processingMarkRecord.svg",
        "path": "processingApplyRecord",
        "id": "ProcessingApplyRecord",
        "processing": true,
        "category": "customer"
    },
    {
        "text": "To do list",
        "icon": "/image/application/processingInbox.svg",
        "path": "processinginbox",
        "id": "ProcessingInbox",
        "processing": true,
        "category": "customer"
    },
    {
        "text": "Notification",
        "icon": "/image/application/notification.svg",
        "path": "notification",
        "id": "Notification",
        "processing": true,
        "category": "customer"
    },
    {
        "text": "Agricultural Product Operator",
        "icon": "/image/application/processingAgriculturalProductOperator.svg",
        "path": "processingAgriculturalProductOperator",
        "id": "ProcessingAgriculturalProductOperator",
        "processing": true,
        "category": "customer"
    },
    {
        "text": "Files download",
        "icon": "/image/application/downloadFiles.svg",
        "path": "payment",
        "id": "DownloadFiles",
        "processing": true,
        "crop": true,
        "category": "customer"
    },
    {
        "text": "Approved Certification",
        "icon": "/image/application/certificationData.svg",
        "path": "certificationData",
        "id": "CertificationData",
        "category": "customer",
        "processing": true
    }
]


export default applets;